import { ProcedureDataModel, ProcedureResultDataModel, UrineCultureGrowth } from "../../Model/index";

export class ProcedureDataContainer {
    ProcedureReports: ProcedureDataModel[] = [];
    ProcedureResults: ProcedureResultDataModel[] = [];
    sessionExpiry: boolean;
    SessionTimeout: string;
	CultureGrowth : UrineCultureGrowth[] = [];
}                   


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/Procedure/ProcedureDataContainer.ts